const isProduction =
  process.env.NODE_ENV === 'production'
    ? true
    : process.env.REACT_APP_NODE_ENV === 'production'
    ? true
    : false
export const BASE_URL = isProduction
  ? 'https://soloflow-khlhb44emq-ue.a.run.app'
  : 'http://localhost:8000'
